import { __decorate } from 'tslib';
import { unsafeCSS, css, LitElement, html } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import css_248z from './text.styles.css.js';

var TextColorEnum;
(function (TextColorEnum) {
    TextColorEnum["primary"] = "primary";
    TextColorEnum["secondary"] = "secondary";
    TextColorEnum["tertiary"] = "tertiary";
    TextColorEnum["positive"] = "positive";
    TextColorEnum["negative"] = "negative";
    TextColorEnum["neutralSofter"] = "neutralSofter";
    TextColorEnum["iconPrimaryInitial"] = "iconPrimaryInitial";
    TextColorEnum["surfaceCanvasPrimaryInitial"] = "surfaceCanvasPrimaryInitial";
    TextColorEnum["warning"] = "warning";
    TextColorEnum["inherit"] = "inherit";
    TextColorEnum["labelNavigationTitle"] = "labelNavigationTitle";
})(TextColorEnum || (TextColorEnum = {}));
var TextPresetEnum;
(function (TextPresetEnum) {
    TextPresetEnum["tab"] = "tab";
    TextPresetEnum["mainButton"] = "mainButton";
    TextPresetEnum["tinyButton"] = "tinyButton";
    TextPresetEnum["linkText"] = "linkText";
    TextPresetEnum["caption"] = "caption";
    TextPresetEnum["caption2"] = "caption2";
    TextPresetEnum["hero"] = "hero";
    TextPresetEnum["headline1"] = "headline1";
    TextPresetEnum["headline2"] = "headline2";
    TextPresetEnum["headline3"] = "headline3";
    TextPresetEnum["headline4"] = "headline4";
    TextPresetEnum["subtitle1"] = "subtitle1";
    TextPresetEnum["subtitle2"] = "subtitle2";
    TextPresetEnum["subtitle3"] = "subtitle3";
    TextPresetEnum["smallText"] = "smallText";
    TextPresetEnum["bigText"] = "bigText";
    TextPresetEnum["paragraph1"] = "paragraph1";
    TextPresetEnum["paragraph2"] = "paragraph2";
    TextPresetEnum["paragraph3"] = "paragraph3";
    TextPresetEnum["paragraph4"] = "paragraph4";
    TextPresetEnum["paragraph5"] = "paragraph5";
})(TextPresetEnum || (TextPresetEnum = {}));
/**
 * Text Component.
 *
 * @element ht-text
 * @csspart text The text content.
 */
let HTText = class HTText extends LitElement {
    constructor() {
        super(...arguments);
        this.preset = 'paragraph1';
        this.color = 'primary';
        this.align = 'left';
        this.textStyle = '';
        this.hiddenText = false;
        this.wordBreak = 'normal';
        this.textWrap = 'wrap';
        this.text = '';
    }
    get textClasses() {
        return classMap({
            text: true,
            '--text-primary': this.color === 'primary',
            '--text-secondary': this.color === 'secondary',
            '--text-tertiary': this.color === 'tertiary',
            '--text-positive': this.color === 'positive',
            '--text-negative': this.color === 'negative',
            '--text-neutral-softer': this.color === 'neutralSofter',
            '--text-icon-nav-and-controls': this.color === 'iconPrimaryInitial',
            '--text-primary-base': this.color === 'surfaceCanvasPrimaryInitial',
            '--text-warning': this.color === 'warning',
            '--label-navigation-title': this.color === 'labelNavigationTitle',
            '--text-inherit-color': this.color === 'inherit' || !this.color,
            '--text-center': this.align === 'center',
            '--text-right': this.align === 'right',
            '--text-left': this.align === 'left',
            '--text-hidden-correction': !!this.hiddenText,
            '--text-wrap-wrap': this.textWrap === 'wrap',
            '--text-wrap-pretty': this.textWrap === 'pretty',
            '--text-wrap-nowrap': this.textWrap === 'nowrap',
            [this.preset]: !!this.preset,
            [this.color]: !!this.color,
            'text-decoration-underline': this.textStyle === 'underline',
            '--capitalize': this.textStyle === 'capitalize',
            '--uppercase': this.textStyle === 'uppercase',
            '--break-all': this.wordBreak === 'break-all',
            '--break-word': this.wordBreak === 'break-word',
            '--break-normal': this.wordBreak === 'normal',
        });
    }
    render() {
        if (this.hiddenText) {
            return html `
        <p class="${this.textClasses}">
          <span>∗∗∗∗∗</span>
        </p>
      `;
        }
        return html `
      <p class="${this.textClasses}">
        ${this.text}
        <slot></slot>
      </p>
    `;
    }
};
HTText.styles = css `
    ${unsafeCSS(css_248z)}
  `;
__decorate([
    property({ type: String })
], HTText.prototype, "preset", void 0);
__decorate([
    property({ type: String })
], HTText.prototype, "color", void 0);
__decorate([
    property({ type: String })
], HTText.prototype, "align", void 0);
__decorate([
    property({ type: String, attribute: 'text-style' })
], HTText.prototype, "textStyle", void 0);
__decorate([
    property({ type: Boolean, attribute: 'hidden-text' })
], HTText.prototype, "hiddenText", void 0);
__decorate([
    property({ type: String, attribute: 'word-break' })
], HTText.prototype, "wordBreak", void 0);
__decorate([
    property({ type: String, attribute: 'text-wrap' })
], HTText.prototype, "textWrap", void 0);
__decorate([
    property({ type: String })
], HTText.prototype, "text", void 0);
HTText = __decorate([
    customElement('ht-text')
], HTText);
var HTText$1 = HTText;

export { TextColorEnum, TextPresetEnum, HTText$1 as default };
//# sourceMappingURL=text.js.map
